import React, { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import PreviewImage from 'components/PreviewImage';

const PREFIX = 'ImagesThumb';

const classes = {
  image: `${PREFIX}-image`,
  imageMoreWrap: `${PREFIX}-imageMoreWrap`,
  imageNumber: `${PREFIX}-imageNumber`,
  container: `${PREFIX}-container`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.image}`]: {
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    objectFit: 'cover',
    maxHeight: '350px',
  },

  [`& .${classes.imageMoreWrap}`]: {
    position: 'relative',
    cursor: 'pointer',
    height: '100%',
    width: '100%',
  },

  [`& .${classes.imageNumber}`]: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '1.2rem',
    color: 'white',
    zIndex: 1,
    cursor: 'pointer',
    fontWeight: 500,
  },

  [`&.${classes.container}`]: {
    display: 'grid',
    minHeight: '120px',
    gridAutoFlow: 'row',
    gridTemplateColumns: 'repeat(3, minmax(80px, 1fr))',
    gap: '5px',
    maxHeight: '350px',
    alignItems: 'start',
  },
}));

export const ImagesThumb = ({ pods, title, style, limitPhotos, onDelete }) => {
  const [isPreview, setIsPreview] = useState(false);
  const imageRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const limit = typeof limitPhotos === 'number' ? limitPhotos : 2;

  const handlePreviewImage = (idx) => {
    setIsPreview(true);
    setCurrentSlide(idx);
    setTimeout(() => {
      if (imageRef.current) imageRef.current.slickGoTo(idx);
    }, 0);
  };

  const handleClosePreview = () => {
    setIsPreview(false);
  };

  return (
    <Root className={classes.container} style={style}>
      {pods?.map((m, idx) => {
        if (idx < limit) {
          return (
            <img
              alt=""
              src={typeof m.url === 'string' ? m.url : URL.createObjectURL(m.url)}
              className={classes.image}
              key={`image-${idx}`}
              onClick={() => handlePreviewImage(idx)}
            />
          );
        }
        if (idx === limit) {
          return (
            <div className={classes.imageMoreWrap} key={`image-${idx}`} onClick={() => handlePreviewImage(idx)}>
              {pods.length - limit - 1 > 0 && <span className={classes.imageNumber}>+{pods.length - limit}</span>}
              <img
                alt=""
                src={typeof m.url === 'string' ? m.url : URL.createObjectURL(m.url)}
                className={classes.image}
                style={{
                  filter: pods.length - 3 > 0 ? 'brightness(0.7) opacity(50%)' : '',
                  WebkitFilter: pods.length - 3 > 0 ? 'brightness(0.7) opacity(50%)' : '',
                  flex: '0 0 100%',
                }}
              />
            </div>
          );
        }
        return null;
      })}
      {title && (
        <PreviewImage
          textTitle={title}
          allowRatingPod={false}
          isPreview={isPreview}
          images={pods}
          imageRef={imageRef}
          handleClosePreview={handleClosePreview}
          deliveryStore={{}}
          setImages={() => {/* empty */}}
          currentSlide={currentSlide}
          setCurrentSlide={(v) => setCurrentSlide(v)}
          onDelete={onDelete}
        />
      )}
    </Root>
  );
};
